import { Expose } from "class-transformer";

export class ConfigureOnboardingRequirementItemDto {
  @Expose()
  id: string;

  @Expose()
  isRequired: boolean;

  @Expose()
  isSelected: boolean;

  @Expose()
  sortOrder?: number;
}
